module.exports = __webpack_public_path__ + "img/picture.67f38671.svg";